import { jsx as _jsx } from "react/jsx-runtime";
import Radio from "@/components/common/Radio";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { alpha, MenuItem } from "@mui/material";
import { useEffect } from "react";
import PassButtonContent from "./PassButtonContent";
const PassMenuItem = (param)=>{
    let { passContent , isSelected , onClick , ...props } = param;
    const backgroundColor = passContent.isDisabled ? "grey.0" : isSelected ? "indigo.0" : "transparent";
    const handleClick = (e)=>{
        if (passContent.isDisabled) return;
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    useEffect(()=>{
        if (isSelected) {
            //mx-221
            mixpanelEvent("Pass Selection Clicked", {
                "Pass Name": passContent.title,
                "Pass Id": passContent.id
            });
        }
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ _jsx(MenuItem, {
        disableRipple: true,
        sx: (theme)=>({
                backgroundColor,
                borderBottom: "1px solid",
                borderColor: "grey.50",
                "&:hover": {
                    backgroundColor: passContent.isDisabled ? "grey.0" : alpha(theme.palette.grey[300], 0.2)
                },
                py: 2
            }),
        onClick: handleClick,
        ...props,
        children: /*#__PURE__*/ _jsx(PassButtonContent, {
            passContent: passContent,
            isSelected: isSelected,
            rightContent: !passContent.isDisabled ? /*#__PURE__*/ _jsx(Radio, {
                size: "small",
                checked: isSelected
            }) : null
        })
    });
};
export default PassMenuItem;
